import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mergeMap, map, catchError, of, switchMap } from 'rxjs';
import * as alarmActions from '../actions/alarm.actions';
import * as rulesActions from '../actions/rules.actions';

import { AlarmService } from '../../services/alarm.service';
import { Store } from '@ngrx/store';
import { showMessage } from '../common/app.action';

@Injectable()
export class AlarmEffects {
  constructor(
    private actions$: Actions,
    private alarmService: AlarmService,
    private store: Store,
  ) {}

  updateAlarm$ = createEffect(() =>
    this.actions$.pipe(
      ofType(alarmActions.updateAlarm),
      switchMap(({ updateAlarmStatusRequest }) =>
        this.alarmService.UpdateAlarmStatus(updateAlarmStatusRequest).pipe(
          switchMap((isSucces) => {
            if (isSucces) {
              this.store.dispatch(
                showMessage({
                  key: 'globalToast',
                  severity: 'success',
                  summary: 'Succès',
                  detail: "Le statut de l'alarme a été mis à jour avec succès.",
                }),
              );
              return of(rulesActions.refreshRules());
            } else {
              return of(
                showMessage({
                  key: 'globalToast',
                  severity: 'error',
                  summary: 'Erreur',
                  detail: "La mise à jour du statut de l'alarme a échoué.",
                }),
              );
            }
          }),
          catchError((error) => of(alarmActions.updateAlarmFailure({ error }))),
        ),
      ),
    ),
  );
}
